import React from 'react'

interface StatusBadgeProps {
    status: string
    className?: string
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
    const colors: Record<string, string> = {
        Active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
        Inactive: 'bg-slate-100 text-slate-600 border-slate-200',
        Pending: 'bg-amber-50 text-amber-700 border-amber-200',
        'On Leave': 'bg-rose-50 text-rose-700 border-rose-200',
    }

    return (
        <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${
                colors[status] || 'bg-gray-50 text-gray-600'
            } ${className}`}
        >
            {status}
        </span>
    )
}

export default StatusBadge
